<template>
  <div style="padding: 20px;overflow: auto" v-loading="isLoading">
    <ul class="monitor_chart">
      <li v-for="(item, index) of chartName" :key="index">
        <p>{{item}}</p>
        <div :id="`myChart${index}`" :style="{width: '100%', height: '200px'}"></div>
        <ul class="chartMask">
          <li><span>前30天</span></li>
          <li><span>前1天</span></li>
          <li><span>前1小时</span></li>
          <li><span>前1分钟</span></li>
          <li><span>前1秒</span></li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'finance',
  data () {
    return {
      isLoading: false,
      chartData: [],
      chartName: [
        '竞价请求数',
        '参与竞价数',
        '展现次数',
        '点击次数',
        '消费金额'
      ]
    }
  },
  created () {
    this.timeFun()
    const timer = setInterval(() => {
      this.timeFun()
    }, 1000)
    this.$once('hook:beforeDestroy', () => {
      clearInterval(timer)
    })
  },
  methods: {
    timeFun () {
      this.getData(0).then(() => {
        this.getData(1).then(() => {
          this.getData(2).then(() => {
            this.getData(3).then(() => {
              this.getData(4)
            })
          })
        })
      })
    },
    // 获取数据
    getData (type) {
      return new Promise((resolve) => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.myOption.requestModule.monitor.children.chart.id
          },
          url: this.myOption.requestUrl + this.myOption.requestModule.monitor.children.chart[`api${type}`],
          data: ''
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            this.chartData[type] = res.data.data.numList
            this.drawLine(type)
            resolve()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
          this.isLoading = false
        })
      })
    },
    // 渲染趋势图
    drawLine (type) {
      let xData = []
      let yData = []
      let lineData = []
      let num
      let data = this.chartData[type]
      const time = Date.parse(new Date())
      for (let i = 0, r = data.length; i < r; i++) {
        if (i === 0) {
          num = 30
        } else if (i === 30) {
          num = 24
        } else if (i === 54 || i === 114) {
          num = 60
        }
        if (i >= 0 && i <= 29) {
          // xData.push(`前${num}天`)
          const newTime = new Date(time - num * 60 * 60 * 24 * 1000)
          xData.push(`${new Date(time).getFullYear()}年${newTime.getMonth() + 1}月${newTime.getDate()}日`)
        } else if (i > 29 && i <= 53) {
          // xData.push(`前${num}小时`)
          const newTime = new Date(time - num * 60 * 60 * 1000)
          xData.push(`${new Date(time).getFullYear()}年${new Date(time).getMonth() + 1}月${newTime.getDate()}日 ${newTime.getHours()}时`)
        } else if (i > 53 && i <= 113) {
          // xData.push(`前${num}分钟`)
          const newTime = new Date(time - num * 60 * 1000)
          xData.push(`${newTime.getHours()}时${newTime.getMinutes()}分`)
        } else if (i > 113 && i <= 173) {
          // xData.push(`前${num}秒`)
          const newTime = new Date(time - num * 1000)
          xData.push(`${new Date(time).getHours()}时${newTime.getMinutes()}分${newTime.getSeconds()}秒`)
        }
        lineData.push(data[i])
        num--
      }
      yData.push({
        color: '#409EFF',
        name: this.chartName[type],
        data: lineData,
        type: 'line',
        symbol: 'none'
      })
      // 基于准备好的dom，初始化echarts实例
      if (!this[`doc_chart${type}`]) {
        this[`doc_chart${type}`] = this.$echarts.init(document.getElementById(`myChart${type}`))
      }
      // 绘制图表
      this[`doc_chart${type}`].setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#000',
          padding: [10, 20],
          textStyle: {
            color: '#fff',
            fontSize: 15
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#409EFF'
            }
          },
          transitionDuration: 0,
          formatter: '{b}<br />{a}: {c}'
        },
        grid: {
          top: '30',
          bottom: '20',
          left: '70',
          right: '20'
        },
        legend: {
          show: false,
          data: '',
          bottom: 0
        },
        xAxis: {
          data: xData,
          type: 'category',
          lineWidth: 1,
          boundaryGap: false,
          silent: true,
          triggerEvent: false,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#999'
            }
          },
          axisTick: {
            show: false,
            inside: true,
            length: 160,
            lineStyle: {
              color: '#ccc',
              width: 1
            }
          },
          axisLabel: {
            color: '#fff',
            interval (index, value) {
              if (index === 0 || index === 29 || index === 53 || index === 113 || index === 173) {
                return true
              }
              return false
            }
          },
          splitLine: {
            show: true
          }
        },
        yAxis: {
          name: type === 4 ? '元' : '次',
          nameLocation: 'end',
          nameTextStyle: {
            color: '#999'
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#ccc'
            }
          },
          axisLabel: {
            color: '#999'
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee'
            }
          },
          splitNumber: 5,
          silent: true,
          minInterval: 1,
          max (value) {
            let num = `${parseInt(value.max)}`.split('')
            if (num[0] * 1 < 5) {
              num[0] = 5
              for (let i = 1, r = num.length; i < r; i++) {
                num[i] = 0
              }
              return num.join('') * 1
            } else {
              num[0] = 1
              for (let i = 1, r = num.length; i < r; i++) {
                num[i] = 0
              }
              return num.join('') * 10
            }
          }
        },
        series: yData
      }, true)
    }
  }
}
</script>

<style scoped>
  .monitor_chart{}
  .monitor_chart>li{
    position: relative;
    margin-bottom: 20px;
    width: 100%;
    border: 1px solid #ccc;
    padding: 20px;
  }
  .monitor_chart>li:last-child{
    margin-bottom: 0;
  }
  .monitor_chart>li>p{
    position: absolute;
    top: 20px;
    right: 20px;
    padding-left: 10px;
    font-size: 14px;
    font-weight: bold;
    color: #666;
    border-left: 6px solid #409EFF;
    line-height: 1;
  }
  .chartMask{
    display: flex;
    position: absolute;
    bottom: 18px;
    left: 20px;
    width: calc(100% - 40px);
    font-size: 12px;
    color: #999;
    word-break:keep-all;
    white-space:nowrap;
  }
  .chartMask>li{
    flex-shrink: 0;
  }
  .chartMask>li>span{
    display: inline-block;
    position: relative;
  }
  .chartMask>li:nth-child(1){
    width: 21.13%;
  }
  .chartMask>li:nth-child(1)>span{
    left: 15%;
  }
  .chartMask>li:nth-child(2){
    width: 13%;
  }
  .chartMask>li:nth-child(2)>span{
    left: -14%;
  }
  .chartMask>li:nth-child(3){
    width: 32.35%;
  }
  .chartMask>li:nth-child(3)>span{
    left: -7%;
  }
  .chartMask>li:nth-child(4){
    width: 32.35%;
  }
  .chartMask>li:nth-child(4)>span{
    left: -6%;
  }
  .chartMask>li:nth-child(5)>span{
    left: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/chart.vue